import Cookies from 'js-cookie'
import {isEmpty} from 'lodash'
import {useSelector} from 'hooks/redux'
import {useLocation} from 'react-router-dom'
import type {User} from 'types/api/users/user'

const defaultLimit = '20'

const limitKey = (pathname: string, userId: string) => `${pathname.replace(/\//g, '')}#${userId}__disp_emp_limit`

export const getSavedDisplaySystemAnnounceLimit = (pathname: string, userId: string): string => {
  if (window.localStorage) {
    const limit = window.localStorage.getItem(limitKey(pathname, userId))
    if (limit && !isEmpty(limit)) {
      return limit
    }
  }
  const limit = Cookies.get(limitKey(pathname, userId))
  if (limit && !isEmpty(limit)) {
    return limit
  }
  return defaultLimit
}

export const saveDisplaySystemAnnounceLimit = (pathname: string, userId: string, limit: string): void => {
  if (window.localStorage) {
    window.localStorage.setItem(limitKey(pathname, userId), limit)
  } else {
    Cookies.set(limitKey(pathname, userId), limit)
  }
}

export const useDisplaySystemAnnounceLimit = (): [string, (limit: string) => void] => {
  const {pathname} = useLocation()
  const user = useSelector((state) => state.session.currentUser) as User | null
  const limit = user?.id ? getSavedDisplaySystemAnnounceLimit(pathname, user.id) : defaultLimit
  const setLimit = (newLimit: string) => {
    if (user?.id) {
      saveDisplaySystemAnnounceLimit(pathname, user.id, newLimit)
    }
  }
  return [limit, setLimit]
}
